/* global $ */

class ThanksContent {
    constructor() {
        if(window.location.search.length > 2) {
            this.init();
        }
    }
    init() {
        const paramString = window.location.search.split('?')[1];
        const params = paramString.split('&');
        const paramObject = {};
        if(params.length) {
            for(let i = 0; i < params.length; i++) {
                paramObject[params[i].split('=')[0]] = params[i].split('=')[1];
            }
        }

        if(paramObject && Object.prototype.hasOwnProperty.call(paramObject, "from")) {
            if(paramObject['from'] == 'request') {
                $('.ThanksContent__body--request').css('display', 'block');
            } else if(paramObject['from'] == 'download') {
                $('.ThanksContent__body--download').css('display', 'block');
            } else if(paramObject['from'] == 'contact') {
                $('.ThanksContent__body--contact').css('display', 'block');
            }
        }
    }
}

export default ThanksContent;